/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Teamcustompages2Inputs */

const en_entity_teamcustompages2 = /** @type {(inputs: Entity_Teamcustompages2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Team Custom Pages`)
};

const de_entity_teamcustompages2 = /** @type {(inputs: Entity_Teamcustompages2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zusatzseiten`)
};

/**
* | output |
* | --- |
* | "Team Custom Pages" |
*
* @param {Entity_Teamcustompages2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_teamcustompages2 = /** @type {((inputs?: Entity_Teamcustompages2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Teamcustompages2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_teamcustompages2(inputs)
	return de_entity_teamcustompages2(inputs)
});
export { entity_teamcustompages2 as "entity_teamCustomPages" }